export const SUPPORTED_LOCALES = ['en', 'es'] as const;
export const DEFAULT_LOCALE = 'en' as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function isValidLocale(value: unknown): value is Locale {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value as Locale);
}
